<div class="title-bar title-bar--responsive">
  <div class="title-bar__heading">
    <h1>PACKAGING</h1>
    <app-help screen="packaging"></app-help>
  </div>
  <div class="title-bar__actions">
    @if (!editMode) {
      <button mat-flat-button color="primary" (click)="setMode('edit')" [disabled]="tabIndex !== 0">Edit Packages</button>
    }
    @if (editMode) {
      <button mat-flat-button color="accent" (click)="setMode('save')">Save Packages</button>
      <button mat-flat-button color="warn" (click)="setMode('cancel')">Cancel</button>
    }
    <app-aid-year [disabled]="editMode"></app-aid-year>
  </div>
</div>

@if (auth.user | async; as user) {
  <mat-tab-group mat-stretch-tabs="false" dynamicHeight [selectedIndex]="tabIndex" (selectedIndexChange)="tabIndex = $event">
    <mat-tab label="Listing">
      <mat-card appearance="outlined">
        @if (cc.packages | async; as packages) {
          <div>
            <div class="packaging-table-wrapper">
              <table class="table table-hover" style="width: auto" cdkDropList (cdkDropListDropped)="drop($event, packages, user.admin)">
                <thead>
                  <tr>
                    <th id="population" scope="col" width="500px" style="padding-left: 2rem">Population</th>
                    <th id="category" scope="col">Category</th>
                    <th id="type" scope="col">Type</th>
                    <th id="amount" scope="col">Amount</th>
                    <th id="input" scope="col">Input or Formula</th>
                  </tr>
                </thead>
                @for (pack of packages; track pack; let i = $index) {
                  <tbody [id]="pack.id" cdkDrag [cdkDragDisabled]="!isPackageDraggable(pack, user.admin)" [attr.tabindex]="isPackageDraggable(pack, user.admin) ? '0' : '-1'">
                    <!-- Package View -->
                    <tr [ngClass]="{ 'required-package': editMode && PackageNamesMap.get(pack.id).required }">
                      <th [id]="pack.id" colspan="5" scope="rowgroup">
                        <strong>{{ PackageNamesMap.get(pack.id).name }}</strong>
                        {{ !pack.enabled ? "(disabled)" : "" }}
                        @if (editMode) {
                          <span>
                            {{ PackageNamesMap.get(pack.id).required ? "(required)" : "" }}
                            @if (!PackageNamesMap.get(pack.id).required) {
                              <span>
                                <mat-button-toggle style="margin-left: 1rem" [checked]="pack.enabled" (change)="pack.enabled = $event.source.checked">{{ !pack.enabled ? "enable" : "disable" }}</mat-button-toggle>
                                @if (!pack.enabled) {
                                  <button mat-button color="warn" style="margin-left: 1rem" (click)="packages.splice(i, 1)">remove package</button>
                                }
                              </span>
                            }
                          </span>
                        }
                      </th>
                    </tr>
                    <!--
                    <button *ngIf="i > 3" mat-icon-button (click)="movePackage('up',packages, i)"><img src="./assets/images/icons8-slide-up.svg"
                    height="25px" width="25px"></button>
                    <button *ngIf="i < packages.length - 1" mat-icon-button (click)="movePackage('down',packages, i)"><img
                    src="./assets/images/icons8-down-button.svg" height="25px" width="25px"></button> -->
                    <!-- Package Rules -->
                    @for (r of pack.rules; track r; let ruleIndex = $index) {
                      @if (editRule !== r) {
                        <tr [ngClass]="{ 'disabled-package': !pack.enabled }" (click)="clickedRow($event, r)">
                          <td [headers]="pack.id + ' population'">
                            <div class="package-rule__cell">
                              @if (editMode) {
                                <button mat-icon-button type="button" class="package-rule__edit-button" (click)="onEditButtonClick($event, r)" [attr.aria-label]="getRuleEditAriaLabel(ruleIndex)" [attr.aria-hidden]="editRule === r ? 'true' : null" [hidden]="editRule === r">
                                  <mat-icon fontIcon="edit" aria-hidden="true"></mat-icon>
                                </button>
                              }
                              <div class="package-rule__details">
                                @if (r.populationId === "1") {
                                  <span>All</span>
                                }
                                @if (r.population; as pop) {
                                  <div>
                                    {{ pop.name }}
                                    @if (!editMode) {
                                      <div class="description">
                                        {{ pop.description }}
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </td>
                          <td [headers]="pack.id + ' category'">{{ r.category }}</td>
                          <td [headers]="pack.id + ' type'">{{ r.assignType }}</td>
                          <td [headers]="pack.id + ' amount'">
                            {{ r.assignType === "Fixed" ? (r.amount | number) : "" }}
                            {{ r.assignType === "Factor" ? r.factor + "%" : "" }}
                          </td>
                          <td [headers]="pack.id + ' input'">
                            @if (r.keyId) {
                              <div>
                                {{ r.keyId | packageSelectorName }}
                              </div>
                            }
                            @if (r.formulaId) {
                              <div>
                                {{ r.formula?.name }}
                                <br />
                                @if (!editMode) {
                                  <span class="description">{{ r.formula?.description }}</span>
                                }
                              </div>
                            }
                            @if (r.assignType === "Table") {
                              <div class="link">{{ r.table?.name }}</div>
                            }
                          </td>
                        </tr>
                      }
                      <!-- Edit a package rule -->
                      @if (editRule === r) {
                        <tr (click)="clickedRow($event, r)" [attr.id]="getRuleRowId(pack.id, ruleIndex)">
                          <td [headers]="pack.id + ' population'">
                            <mat-form-field class="form-field" style="width: 20rem">
                              <mat-label>Select Population</mat-label>
                              <mat-select placeholder="Select Population" [(value)]="r.populationId" (selectionChange)="setRulePopulation(r)" [aria-labelledby]="'Select Population ' + r.populationName">
                                <mat-option value="1" id="All">All</mat-option>
                                @for (pop of cc.populations | async; track pop) {
                                  <mat-option [value]="pop.id">
                                    {{ pop.name }}
                                  </mat-option>
                                }
                              </mat-select>
                              @if (r.population; as pop) {
                                <mat-hint>{{ pop.description.substring(0, 100) + (pop.description.length > 100 ? "..." : "") }}</mat-hint>
                              }
                            </mat-form-field>
                            <div>
                              <button mat-button color="warn" style="padding-left: 0" (click)="removeRule(pack, ruleIndex)" [attr.aria-labelledby]="getRemoveRuleLabelId(pack.id, ruleIndex) + ' ' + getRuleRowId(pack.id, ruleIndex)">
                                <span [attr.id]="getRemoveRuleLabelId(pack.id, ruleIndex)">remove rule</span>
                              </button>
                            </div>
                          </td>
                          <td [headers]="pack.id + ' category'">
                            <mat-form-field style="width: 8rem">
                              <mat-label>Category</mat-label>
                              <mat-select placeholder="Category" [(value)]="r.category" [aria-labelledby]="'Category ' + r.category">
                                <mat-option value="Assignment">Assignment</mat-option>
                                <mat-option value="Cap">Cap</mat-option>
                                <!-- TODO: Disable if there is already a floor (or move floor rules to package) -->
                                <mat-option value="Floor" [disabled]="false">Floor</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td [headers]="pack.id + ' type'">
                            <mat-form-field style="width: 8rem">
                              <mat-label>Type</mat-label>
                              <mat-select placeholder="Type" [(value)]="r.assignType" (selectionChange)="onAssignTypeChange(r)" [aria-labelledby]="'Type ' + r.assignType">
                                <mat-option value="Factor">Factor</mat-option>
                                <mat-option value="Fixed">Fixed</mat-option>
                                <mat-option value="Table">Table</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td [headers]="pack.id + ' amount'">
                            @if (r.assignType === "Fixed") {
                              <div>
                                <mat-form-field style="width: 5em">
                                  <mat-label>Amount</mat-label>
                                  <input matInput placeholder="Amount" type="number" [(ngModel)]="r.amount" />
                                </mat-form-field>
                              </div>
                            }
                            @if (r.assignType === "Factor") {
                              <div>
                                <mat-form-field style="width: 5em">
                                  <mat-label>Factor</mat-label>
                                  <input matInput placeholder="Factor" type="number" [(ngModel)]="r.factor" min="0" max="100" pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" />
                                  <span matSuffix>%</span>
                                </mat-form-field>
                              </div>
                            }
                          </td>
                          <td [headers]="pack.id + ' input'">
                            @if (r.assignType === "Factor") {
                              <div>
                                <input-selector [key]="r" [caller]="'Package'"></input-selector>
                              </div>
                            }
                            @if (r.assignType === "Table") {
                              <div>
                                <mat-form-field>
                                  <mat-label>Select Table</mat-label>
                                  <mat-select placeholder="Select Table" [(value)]="r.table" (selectionChange)="r.tableId = r.table?.tableId" [aria-labelledby]="'Select Table ' + (r.table ? r.table.name : '')">
                                    @for (table of cc.tables | async; track table) {
                                      <mat-option [value]="table">
                                        {{ table.name }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    }
                    @if (editMode) {
                      <tr class="table-sm">
                        <td colspan="5" style="padding-left: 1rem"><button mat-button color="accent" style="line-height: 24px" (click)="addRule(pack)">add rule</button></td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
            @if (editMode) {
              <div>
                <mat-form-field style="margin-left: 1rem">
                  <mat-label>Add Unused Package</mat-label>
                  <mat-select placeholder="Add Unused Package">
                    @for (pack of unusedPackages; track pack) {
                      <mat-option (onSelectionChange)="addPackage(pack.id, packages)">
                        {{ pack.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <p></p>
          </div>
        }
      </mat-card>
    </mat-tab>
    @if (!editMode) {
      <mat-tab label="Caps and Floors">
        <p></p>
        <app-package-overrides></app-package-overrides>
      </mat-tab>
      <mat-tab label="Configuration">
        <p></p>
        <app-packaging-config></app-packaging-config>
      </mat-tab>
    }
    <mat-tab [label]="tableName" [disabled]="tableName === ''">
      @if (table) {
        <app-table [table]="table" [showActions]="false"></app-table>
      }
    </mat-tab>
  </mat-tab-group>
}
